var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAmexinline = function SvgAmexinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.804 24.728L58.3 33.634l-3.49-8.882h-6.774v14.305L41.097 24.74h-5.561l-7.034 14.442h4.825l1.323-2.886h7.183l1.323 2.886h9.133v-9.914l4.048 9.914h3.83l3.968-9.89v9.915h4.185v-14.48h-6.516zm-25.669 8.309l2.113-4.59 2.113 4.59h-4.226zm6.462-10.325l3.053 6.344v-6.344h10.756l1.854 4.752 1.853-4.752h8.207v-8.545H11.667v51.697H68.32v-8.16h-6.666l-3.544-3.558-3.517 3.582-22.397-.05V41.235H24.93l8.943-18.522h8.724zm20.23 18.485l-.042.037-4.512 4.54-4.498-4.54-.041-.037H34.609v14.454H53.57l4.567-4.627 4.62 4.627h5.563V41.197h-5.494zM48.035 55.589v-3.321h-9.079V50.04h8.86V46.77h-8.86v-2.264h9.079v-3.272L55.41 48.4l-7.374 7.178v.012z",
    fill: "#006FD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.411 39.182l-2.276.025v-.025h2.276zM68.333 55.651v2.053h-6.666l-3.544-3.558-3.517 3.582-22.397-.05V41.235h2.413v14.417h18.962l4.566-4.627 4.622 4.627h5.561z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.05 55.602V52.28h-9.08v-2.226h8.861v-3.272h-8.86v-2.264h9.078V41.26l7.361 7.153-7.36 7.19z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.826 41.197l-.04.037-4.513 4.54-4.498-4.54-.041-.037H34.609v14.454H53.57l4.567-4.627 4.62 4.627h5.563v-3.16l-4.172-4.117 4.172-4.067v-3.098h-5.494v-.012zm-14.79 14.392v-3.321h-9.079V50.04h8.86V46.77h-8.86v-2.264h9.079v-3.272L55.41 48.4l-7.374 7.178v.012z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.785 41.234l-4.512 4.54-4.498-4.54h9.01z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.05 41.197v3.321h-9.08v2.264h8.861v3.272h-8.86v2.226h9.078v3.371H34.622V41.197H48.05z",
    fill: "#006FD4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.333 41.197v.112l-7.265 7.103 7.265 7.04v.2h-5.561l-4.621-4.628-4.567 4.627H47.98l.068-.05 7.361-7.19-7.36-7.152-.069-.062h5.753l.04.037 4.5 4.54 4.511-4.54.041-.037h5.507z",
    fill: "#006FD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.333 22.712v2.016h-6.53L58.3 33.634l-3.49-8.894-6.76-.012v14.317l-6.94-14.317h-5.574l-7.034 14.441h3.707v2.065h-7.265l8.942-18.522h8.71l3.054 6.344v-6.344h10.756l1.854 4.752 1.853-4.752h8.22z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.17 39.17l-9.83-.013 1.31-2.873h7.197l1.322 2.885z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.785 41.234h5.535v-.037h-5.494l-.04.037zm-.981-16.506L58.3 33.634l-3.49-8.882h-6.774v14.305L41.097 24.74h-5.561l-7.034 14.442h4.825l1.323-2.886h7.183l1.323 2.886h9.133v-9.914l4.048 9.914h3.83l3.968-9.89v9.915h4.185v-14.48h-6.516zm-25.669 8.309l2.113-4.59 2.113 4.59h-4.226zm11.9 8.16H34.61v.037H53.76l-.04-.037h-5.699.014z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.333 39.182v2.015h-5.507l-.04.037h-9.011l-.041-.037H34.622v.037H32.21V39.17h1.132v-.012l9.828.012h4.935l16.03.013v.025l2.277-.025h1.922z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.135 29.28v9.902l-16.031-.013h4.199v-9.914l4.048 9.914h3.83l3.954-9.889z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.05 39.045l-6.94-14.317h-5.56l-7.035 14.441h4.826l1.322-2.886h7.184l1.322 2.886h4.935l-.055-.124zm-11.901-6.008l2.113-4.59 2.113 4.59h-4.226z",
    fill: "#006FD4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.361 33.037h-4.226l2.113-4.59 2.113 4.59z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.333 24.728v14.441l-1.922.013-2.276.025V29.28l-3.953 9.89h-3.83l-4.05-9.915v9.914H48.05V24.728l6.762.012 3.49 8.894 3.503-8.906h6.53z",
    fill: "#006FD4"
  })));
};
export default SvgAmexinline;